import React from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  OrderedList,
  ListItem,
  Box,
  Text,
} from "@chakra-ui/react";

interface GaraazGeneralPopoverProps {
  title: string;
  value: Record<string, any>[];
  trigger: React.ReactNode;
}

const GaraazGeneralPopover: React.FC<GaraazGeneralPopoverProps> = ({
  title,
  value,
  trigger,
}) => (
  <Popover returnFocusOnClose={false} trigger="hover">
    <PopoverTrigger>{trigger}</PopoverTrigger>
    <PopoverContent zIndex="popover" p="10px" w="400px">
      <Text color="#4A5567" fontSize="lg" fontWeight="bold" mb={2}>
        {title}
      </Text>
      {value?.map((item: any, idx: number) => (
        <Box
          key={idx}
          borderTop={idx >= 1 ? "1px solid lightgrey" : "none"}
          pt={idx >= 1 ? 2 : 0}
        >
          <OrderedList fontSize="sm" listStyleType="none" marginLeft={0}>
            {Object.entries(item).map(([k, v]) => (
              <ListItem key={k} display="flex" mb={1}>
                <Text fontWeight="medium" minW="120px">
                  {k}:
                </Text>
                <Text
                  as="span"
                  whiteSpace="nowrap"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  maxW="210px"
                  title={String(v ?? "")}
                >
                  {String(v ?? "").length > 30 ? (
                    <Box as="span" title={String(v ?? "")}>
                      {String(v ?? "").substring(0, 30) + "..."}
                    </Box>
                  ) : (
                    String(v ?? "")
                  )}
                </Text>
              </ListItem>
            ))}
          </OrderedList>
        </Box>
      ))}
    </PopoverContent>
  </Popover>
);

export default GaraazGeneralPopover;
